// extracted by mini-css-extract-plugin
export default {"title":"svPqbsW-qy4+sZcLOBBQ7Q==","lockIcon":"MHp6s+YvXw6pPApUuyi6Sg=="};